import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { formatValue } from 'modules/core/components/ActivityLog/Log/functions'
import { Change } from 'modules/core/components/ActivityLog/Log/types'

export const Tag = ({ change }: Change) => {
  const [isHover, setIsHover] = useState<boolean>(false)

  const navigate = useNavigate()

  const goToLink = () => {
    navigate(String(change.link))
  }

  return (
    <Box
      flexDirection="row"
      borderRadius={{ all: 'abs008' }}
      border={{ all: { width: 's2', style: 'solid', color: 'grey400' } }}
      width="fit-content"
      alignItems="center"
      padding="s6"
      paddingRight="s12"
      background="grey000White"
      gap="s4"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      {...(isHover &&
        change.link && { cursor: 'pointer', background: 'grey200', onClick: goToLink })}
    >
      {change.icon && <Icon.Medium icon={change.icon} color="grey700" />}
      {change.old_value && (
        <Text.Normal size="200" weight="normal" color="grey600" stroked>
          {formatValue(change.old_value.value)}
        </Text.Normal>
      )}
      {change.old_value && change.value && <Icon.Medium icon="arrow-right" color="grey800" />}
      {change.value && (
        <Text.Normal size="200" weight="normal" color="grey800">
          {formatValue(change.value.value)}
        </Text.Normal>
      )}
    </Box>
  )
}
